// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SetupFee_StatusResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SetupFee_StatusResponseDados {
franquia_id: number
status: string
source?: string
pending_charge_id?: number
checkout_url?: string
}

export type SetupFee_StatusResponse = ApiResponse<SetupFee_StatusResponseDados>;

registerResponseContract('SetupFee_StatusResponse', {
  franquia_id:       { type: 'number',  required: true },
  status:            { type: 'string',  required: true },
  source:            { type: 'string',  required: false },
  pending_charge_id: { type: 'number',  required: false },
  checkout_url:      { type: 'string',  required: false },
})
